import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../App';

const Sidebar = () => {
  const location = useLocation();
  const { hasPermission } = useAuth();

  const menuItems = [
    {
      name: 'Giao dịch ví',
      path: '/transactions',
      icon: 'M12 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 10c-4.41 0-8-1.79-8-4V6c0-2.21 3.59-4 8-4s8 1.79 8 4v8c0 2.21-3.59 4-8 4z',
      permission: { resource: 'finance', action: 'read' }
    },
    {
      name: 'Dashboard',
      path: '/',
      icon: 'M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2H5a2 2 0 00-2 2v-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10',
      permission: null
    },
    {
      name: 'Dự án',
      path: '/projects',
      icon: 'M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10',
      permission: { resource: 'project', action: 'read' }
    },
    {
      name: 'Khách hàng',
      path: '/customers',
      icon: 'M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z',
      permission: { resource: 'customer', action: 'read' }
    },
    {
      name: 'Nhà cung cấp',
      path: '/suppliers',
      icon: 'M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4',
      permission: { resource: 'supplier', action: 'read' }
    },
    {
      name: 'Hosting & Domain',
      path: '/hosting-domains',
      icon: 'M5 12h14M5 12a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v4a2 2 0 01-2 2M5 12a2 2 0 00-2 2v4a2 2 0 002 2h14a2 2 0 002-2v-4a2 2 0 00-2-2m-2-4h.01M17 16h.01',
      permission: { resource: 'hosting', action: 'read' }
    },
    {
      name: 'SEO',
      path: '/seo',
      icon: 'M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z',
      permission: { resource: 'seo', action: 'read' }
    },
    {
      name: 'Hợp đồng',
      path: '/contracts',
      icon: 'M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z',
      permission: { resource: 'finance', action: 'read' }
    },
    {
      name: 'Support Tickets',
      path: '/tasks',
      icon: 'M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z',
      permission: { resource: 'task', action: 'read' }
    },
    {
      name: 'Người dùng',
      path: '/users',
      icon: 'M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z',
      permission: { resource: 'user', action: 'read' }
    },
    {
      name: 'Phân quyền',
      path: '/roles',
      icon: 'M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z',
      permission: { resource: 'user', action: 'write' }
    },
    {
      name: 'Quyền hạn',
      path: '/permissions',
      icon: 'M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z',
      permission: { resource: 'user', action: 'write' }
    }
  ];

  const isActive = (path) => {
    return location.pathname === path;
  };

  const canAccess = (permission) => {
    if (!permission) return true;
    return hasPermission(permission.resource, permission.action);
  };

  return (
    <div className="bg-dark-900 border-r border-cyan-500/20 text-white w-64 min-h-screen">
      {/* Logo Section */}
      <div className="p-5 border-b border-cyan-500/10">
        <div className="flex items-center space-x-3">
          <div className="h-10 w-10 bg-gradient-to-br from-cyan-500 to-blue-600 rounded-xl flex items-center justify-center shadow-glow-cyan">
            <span className="text-white font-bold text-lg">S</span>
          </div>
          <div>
            <span className="text-lg font-bold bg-gradient-to-r from-cyan-400 to-blue-400 bg-clip-text text-transparent">Smartera</span>
            <p className="text-xs text-ocean-100/50">Admin Panel</p>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <nav className="mt-6 px-3">
        <div className="space-y-1">
          {menuItems.map((item) => {
            if (!canAccess(item.permission)) return null;

            return (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center space-x-3 px-4 py-3 rounded-xl transition-all duration-200 group ${
                  isActive(item.path)
                    ? 'bg-gradient-to-r from-cyan-500/20 to-blue-500/20 text-cyan-400 border border-cyan-500/30 shadow-glow-cyan/20'
                    : 'text-ocean-100/70 hover:bg-cyan-500/10 hover:text-cyan-400 border border-transparent'
                }`}
              >
                <svg
                  className={`h-5 w-5 transition-colors ${
                    isActive(item.path) ? 'text-cyan-400' : 'text-ocean-100/50 group-hover:text-cyan-400'
                  }`}
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={item.icon} />
                </svg>
                <span className="text-sm font-medium">{item.name}</span>
                {isActive(item.path) && (
                  <div className="ml-auto w-1.5 h-1.5 bg-cyan-400 rounded-full animate-pulse"></div>
                )}
              </Link>
            );
          })}
        </div>
      </nav>

      {/* Bottom Section */}
      <div className="absolute bottom-0 left-0 right-0 p-4 border-t border-cyan-500/10">
        <div className="flex items-center gap-3 px-3 py-2 rounded-xl bg-dark-800/50">
          <div className="w-2 h-2 bg-emerald-400 rounded-full animate-pulse"></div>
          <span className="text-xs text-ocean-100/60">System Online</span>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
